export var EN_US = 'en-US';
export var FR_CA = 'fr-CA';
export var ES_419 = 'es-419';
